"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformImageApi = exports.SdPlatformImageQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Platform image emedabble fields.
 */
var SdPlatformImageQueryEmbeddableFields;
(function (SdPlatformImageQueryEmbeddableFields) {
    SdPlatformImageQueryEmbeddableFields["User"] = "user";
    SdPlatformImageQueryEmbeddableFields["Models"] = "models";
})(SdPlatformImageQueryEmbeddableFields = exports.SdPlatformImageQueryEmbeddableFields || (exports.SdPlatformImageQueryEmbeddableFields = {}));
/**
 * Operations for images which can be attached to models.
 */
class SdPlatformImageApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "images";
    }
    /**
     * Get image by id
     * @param id - the id of an image.
     * @param embed - array of {@link SdPlatformImageQueryEmbeddableFields} fields to embed.
     * @returns image
     */
    get(id, embed = []) {
        return super.__get(SdPlatformRequestId_1.RequestId.ImageGet, id, embed);
    }
    /**
     * Queries images
     * @param body - {@link SdPlatformImageQueryParameters} as body.
     *
     * @remarks body is optional.
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.ImageQuery, body);
    }
    /**
     * Create an image
     * @param body {@link SdPlatformRequestImageCreate}
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.ImageCreate, body);
    }
    /**
     * Delete image by id
     * @param id - image id.
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.ImagesDelete, id);
    }
}
exports.SdPlatformImageApi = SdPlatformImageApi;
//# sourceMappingURL=SdPlatformImageApi.js.map